import React, { Component } from 'react'
import { withRouter, Link } from "react-router-dom";
import { Container, Nav, Navbar, Button } from 'react-bootstrap'
import './_navbars.scss';



class ExpiresExamHistoryNavbar extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render() {
        console.log("ExamHistoryNavbar", this.props);
        return (
            <Navbar bg="white" className="examtop-header header-top shadow-sm" expand="md">
                <Container>
                    <div className="nav-brand">
                        <Button variant="light" className="px-2 py-1 mr-2" onClick={() => this.props.onClick()}>
                            <i className="fal fa-bars" />
                        </Button>
                    </div>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <div className="mr-auto" inline="true">
                            <Button variant="link text-dark"
                                onClick={this.props.history.goBack}
                            >Go Back</Button>
                        </div>

                        <Nav className="mx-auto">
                            <h6 className="title text-muted mr-3">Question and Answers View</h6>
                        </Nav>
                        

                       

                    </Navbar.Collapse>
                </Container>

            </Navbar>
        )
    }
}

export default withRouter(ExpiresExamHistoryNavbar);
